import { Model } from '@/services/api/lib'

class Template extends Model {
  resource () {
    return 'cms/v1/templates'
  }

  defaults () {
    return {
      name: ''
    }
  }

  validations () {
    return {
      'name': 'required|string'
    }
  }
}

class Page extends Model {
  resource () {
    return 'cms/v1/pages'
  }

  defaults () {
    return {
      name: '',
      content: '',
      slug: '',
      scripts: '',
      type: 'raw_html',
      translations: null
    }
  }

  validations () {
    return {
      'name': 'required|string',
      'slug': 'required|string',
      'type': 'required|string',
      'content': 'string',
      'scripts': 'string',
      'code': 'string'
    }
  }
}

class Component extends Model {
  resource () {
    return 'cms/v1/components'
  }

  defaults () {
    return {
      name: '',
      content: '',
      code: '',
      type: 'raw_html',
      translations: null
    }
  }

  validations () {
    return {
      'name': 'required|string',
      'type': 'required|string',
      'code': 'required|string',
      'content': 'string'
    }
  }
}

class Settings extends Model {
  resource () {
    return 'cms/v1/settings'
  }

  validations () {
    return {
      'label': 'string',
      'description': 'string',
      'code': 'required|string',
      'type': 'required|string',
      'options': 'array',
      'meta': 'object',
      'value': 'required|any',
      'validation': 'string'
    }
  }

  updateValue (id, value, config = {}) {
    const url = `cms/v1/settings/${id}`

    return this.request({
      ...config,
      url,
      method: 'PUT',
      data: { value }
    })
  }
}

export default {
  Template,
  Page,
  Component,
  Settings
}
